import locales from "@/lib/publicLocales.json";
import { ENGINE_LANGS } from "@/i18n/languages";

export const isPublicLangReviewed = (lang) => lang === "es" || locales[lang]?.reviewed === true;

// `visible` ensena los enlaces al idioma; `reviewed` decide la indexacion. Son compuertas distintas.
export const isPublicLangVisible = (lang) => lang === "es" || locales[lang]?.visible === true;

export const isAppLangOpen = (lang) => lang === "es" || locales[lang]?.app === true;

export const isLegalLangOpen = (lang) => lang === "es" || locales[lang]?.legal === true;

// lang_preview abre un idioma que existe, no cualquiera: sin la lista, "fr" con preview saldria como valido.
export const canUseAppLang = (lang, user) =>
  ENGINE_LANGS.includes(lang) && (isAppLangOpen(lang) || user?.lang_preview === true);

export function alternatePath(path, lang) {
  if (lang === "es") {
    const hit = Object.entries(locales).flatMap(([, v]) => Object.entries(v.paths)).find(([, to]) => to === path);
    return hit ? hit[0] : null;
  }
  return locales[lang]?.paths?.[path] || null;
}
